<template>
  <BContainer
    v-if="user"
    fluid
  >
    <BRow
      class="pb-5 mx-1"
    >
      <BCol
        cols="12"
        class="px-0"
      >
        <BRow
          class="py-1 mx-0"
        >

          <BCol
            cols="12"
            class="p-2 border-bottom"
          >
            <h5 class="text-center text-md-left font-weight-bold">
              Purchase Orders
            </h5>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'scm.purchase-orders.approvals', params: { approver: 'pending' }}">
              <Card
                :loading="fetching"
                :count="purchaseOrders.pending"
                title="Pending"
                sub-title="PO Approvals"
                variant="dark"
                icon="fad fa-file-lines"
              />
            </router-link>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'scm.purchase-orders.approvals', params: { approver: 'histories', status: 'approved' }}">
              <Card
                :loading="fetching"
                :count="purchaseOrders.approved"
                title="Approved"
                sub-title="PO Approvals"
                variant="success"
                icon="fad fa-file-check"
              />
            </router-link>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'scm.purchase-orders.approvals', params: { approver: 'histories', status: 'disapproved' }}">
              <Card
                :loading="fetching"
                :count="purchaseOrders.disapproved"
                title="Disapproved"
                sub-title="PO Approvals"
                variant="danger"
                icon="fad fa-file-times"
              />
            </router-link>
          </BCol>

        </BRow>
      </BCol>

      <BCol
        cols="12"
        class="px-0"
      >
        <BRow
          class="py-1 mx-0"
        >

          <BCol
            cols="12"
            class="p-2 border-bottom mt-4"
          >
            <h5 class="text-center text-md-left font-weight-bold">
              Authority to Withdraws
            </h5>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'scm.atws.approvals', params: { approver: 'pending' }}">
              <Card
                :loading="fetching"
                :count="atws.pending"
                title="Pending"
                sub-title="ATW Approvals"
                variant="dark"
                icon="fad fa-file-lines"
              />
            </router-link>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'scm.atws.approvals', params: { approver: 'histories', status: 'approved' }}">
              <Card
                :loading="fetching"
                :count="atws.approved"
                title="Approved"
                sub-title="ATW Approvals"
                variant="success"
                icon="fad fa-file-check"
              />
            </router-link>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'scm.atws.approvals', params: { approver: 'histories', status: 'disapproved' }}">
              <Card
                :loading="fetching"
                :count="atws.disapproved"
                title="Disapproved"
                sub-title="ATW Approvals"
                variant="danger"
                icon="fad fa-file-times"
              />
            </router-link>
          </BCol>

        </BRow>
      </BCol>

      <BCol
        cols="12"
        class="px-0"
      >
        <BRow
          class="py-1 mx-0"
        >

          <BCol
            cols="12"
            class="p-2 border-bottom mt-4"
          >
            <h5 class="text-center text-md-left font-weight-bold">
              Inter Warehouses
            </h5>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'scm.inter-warehouses.approvals', params: { approver: 'pending' }}">
              <Card
                :loading="fetching"
                :count="interWarehouses.pending"
                title="Pending"
                sub-title="IW Approvals"
                variant="dark"
                icon="fad fa-file-lines"
              />
            </router-link>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'scm.inter-warehouses.approvals', params: { approver: 'histories', status: 'approved' }}">
              <Card
                :loading="fetching"
                :count="interWarehouses.approved"
                title="Approved"
                sub-title="IW Approvals"
                variant="success"
                icon="fad fa-file-check"
              />
            </router-link>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'scm.inter-warehouses.approvals', params: { approver: 'histories', status: 'disapproved' }}">
              <Card
                :loading="fetching"
                :count="interWarehouses.disapproved"
                title="Disapproved"
                sub-title="IW Approvals"
                variant="danger"
                icon="fad fa-file-times"
              />
            </router-link>
          </BCol>

        </BRow>
      </BCol>

    </BRow>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

import Card from '@/components/custom/Card.vue'

import { SSCMDashboard } from '@/services/scm'

export default {
  name: 'VSupplyChainManagerDashboard',

  middleware: ['auth', 'scm'],

  components: {
    Card
  },

  mixins: [
    MISC,
    FORMATTER
  ],

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      fetching: false,
      borderRight: !this.isMobile(),
      purchaseOrders: {
        pending: 0,
        disapproved: 0,
        approved: 0
      },
      interWarehouses: {
        pending: 0,
        disapproved: 0,
        approved: 0
      },
      atws: {
        pending: 0,
        disapproved: 0,
        approved: 0
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  mounted () {
    if (this.user) {
      this.getStatistics()
    }
  },

  methods: {
    async getStatistics () {
      this.fetching = true
      return SSCMDashboard.getStatistics().then(({ data }) => {
        this.purchaseOrders = {
          pending: data?.purchase_order_approval_total_pending || 0,
          approved: data?.purchase_order_approval_total_approved || 0,
          disapproved: data?.purchase_order_approval_total_disapproved || 0
        }

        this.interWarehouses = {
          pending: data?.inter_warehouse_approval_total_pending || 0,
          approved: data?.inter_warehouse_approval_total_approved || 0,
          disapproved: data?.inter_warehouse_approval_total_disapproved || 0
        }

        this.atws = {
          pending: data?.stock_withdrawal_approval_total_pending || 0,
          approved: data?.stock_withdrawal_approval_total_approved || 0,
          disapproved: data?.stock_withdrawal_approval_total_disapproved || 0
        }
      }).catch(() => {
        this.purchaseOrders = {
          pending: 0,
          approved: 0,
          disapproved: 0
        }

        this.interWarehouses = {
          pending: 0,
          approved: 0,
          disapproved: 0
        }

        this.atws = {
          pending: 0,
          approved: 0,
          disapproved: 0
        }
      }).finally(() => {
        this.fetching = false
      })
    }
  }
}
</script>
